import {useNavigate} from "react-router-dom";
import { useSnackbar } from "notistack";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
} from "@mui/material";
import {useEffect, useState} from "react";
import * as React from 'react';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import * as XLSX from 'xlsx';
import sendRequest from "../services/sendRequest";
import MoonLoader from "react-spinners/MoonLoader";
import DownloadIcon from "@mui/icons-material/Download"; // Import
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

const UnknowAssetsUpload =({open, close, selected, setRefresh}) => {

const { enqueueSnackbar,closeSnackbar } = useSnackbar()
const [items, setItems] = useState([]);
const [formData, setFormData] = useState({});
const [fullWidth, setFullWidth] = React.useState(true);
const [maxWidth, setMaxWidth] = React.useState('sm');
let [loading, setLoading] = useState(false);
let [color, setColor] = useState("#000000");
const page ="assets";
const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

  const handleClose = () => {
      close();
  };

  useEffect(() => {
  });

  // handle file upload
  const handleFileUpload = (e) => {
    const numberOfColumns = 2;
    if (numberOfColumns == 2) {
      try {
        setLoading(true); // Indicate loading state
        const file = e.target.files[0]; // Get the uploaded file
        if (!file) {
          console.error("No file selected");
          setLoading(false);
          return;
        }
        const reader = new FileReader();
        reader.onload = async (event) => {
          const fileContent = event.target.result; // Get the file content
          // Split the content into lines
          const lines = fileContent.split('\n');
          // Initialize an array to store the objects
          const items = [];
          let tempRecord = null;
          for (let line of lines) {
            // Trim whitespace from the line
            line = line.trim();
            if (!line) continue; // Skip empty lines
            // Check if the line is incomplete (e.g., starts with a quote but doesn't end with one)
            if (line.startsWith('"') && !line.endsWith('"')) {
              tempRecord = line; // Start collecting the incomplete record
              continue;
            }
            if (tempRecord) {
              // Combine the incomplete record with the current line
              line = tempRecord + line;
              tempRecord = null; // Reset tempRecord
            }
            // Split the line using a comma as the delimiter
            const parts = line.split(',');
            // Remove quotes from the fields
            const asset_id = parts[0]?.replace(/"/g, '')?.trim();
            const custom_id = parts[1]?.replace(/"/g, '')?.trim();
            if (asset_id && custom_id) {
              // Create an object for the row
              const item = { asset_id, custom_id };
              items.push(item);
            } else {
              console.warn(`Skipping malformed line: ${line}`);
            }
          }
 
          // Function to chunk an array into smaller arrays of a specified size
          function chunkArray(array, chunkSize) {
            const chunks = [];
            for (let i = 0; i < array.length; i += chunkSize) {
              chunks.push(array.slice(i, i + chunkSize));
            }
            return chunks;
          }
 
          // Split items into chunks of 1000 records each
          const chunks = chunkArray(items, 1000);
 
          try {
            // Process each chunk sequentially
            for (const chunk of chunks) {
              const response = await sendRequest({
                requestType: "put",
                endpoint: `${page}?fileupload=${"yes"}`,
                requestData: chunk,
              });
              console.log('Response:', response);
              if (response.status !== 200) {
                handleAllTypesOfMessages('There is an Error with the file, Please Check the .csv file and Reupload it!', 'error'); // Handle error for failed chunk
                setLoading(false);
                return; // Exit the loop if an error occurs
              }
            } 
            // If all chunks are processed successfully
            setItems([]);
            handleAllTypesOfMessages('The Data updated Successfully!', 'success'); // Show success message
            handleClose(); // Close the popup
          } catch (error) {
            console.error("An error occurred:", error);
            handleAllTypesOfMessages('There is an Error with the file, Please Check the .csv file and Reupload it!', 'error');
            setLoading(false);
          } finally {
            setLoading(false);
          }
        };

        reader.onerror = (error) => {
          console.error("Error reading file:", error);
          setLoading(false);
        };
        reader.readAsText(file); // Read the file as text           
      } catch (error) {
        console.error("An error occurred:", error);
        handleAllTypesOfMessages('There is an Error with the file, Please Check the .csv file and Reupload it!', 'error');
        setLoading(false);
      }
    } else {
      setItems([]);
      handleAllTypesOfMessages('The file should contains only 2 Columns [Asset ID and Custom ID] with no headers', 'error');
      handleClose();
    }
  };

  const handleDownloadAssetsTemplate = () => {
      // Define the data
      const data = [
        [
          "Asset ID",
          "Custom ID",
        ],
        [
          "A999541686211992",
          "ECN-MLS-S000-EP000",
        ],
        [
          "A999576683485951",
          "ECN-MLS-S000-EP000",
        ],
      ];
    
      // Create a workbook and worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Assets");
    
      // Adjust column widths
      const columnWidths = data[0].map((header) => ({ wch: header.length + 5 }));
      worksheet["!cols"] = columnWidths;
    
      // Write the workbook to a file
      XLSX.writeFile(workbook, "Assets_Bulk.csv");
    };

  //handleAllTypesOfMessages
  // const handleAllTypesOfMessages = (message, type) => {
  //   enqueueSnackbar(message, {
  //     variant: type,
  //   });
  // };

  //handleAllTypesOfMessages
  const handleAllTypesOfMessages = (message, type) => {
    const action = (key) => (
      <IconButton
      aria-label="close"
      color="inherit"
      onClick={() => closeSnackbar(key)}
      >
      <CloseIcon />
      </IconButton>
    );

    enqueueSnackbar(message, {
      variant: type,
      anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
      },
      persist: true, // <- keeps the snackbar visible until manually closed
      // autoHideDuration: 20000,
      action
    });
  };

  return (
    <Dialog
    open={open}
    onClose={() => {
      close();
    }}
    >
      <DialogContent>
        <Dialog
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            open={open}
            onClose={handleClose}
          >
            <MoonLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={40}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
            <DialogTitle sx={{ textAlign: 'center' }}>Upload CSV</DialogTitle>
            <DialogContent sx={{ marginBottom: 2 }}>
              <DialogContentText sx={{ textAlign: 'center' , whiteSpace: 'normal', wordWrap: 'break-word', marginBottom: 2}}>
                Upload a CSV file to bulk update Asset ID and Custom ID values:
                <Button
                variant="contained"
                color="primary"
                startIcon={<DownloadIcon />}
                onClick={handleDownloadAssetsTemplate}
              ></Button>
              </DialogContentText>
              
              <DialogContentText sx={{ textAlign: 'center' , whiteSpace: 'normal', wordWrap: 'break-word', marginBottom: 2}}>
                The .CSV file should contains only 2 Columns 1)Asset ID 2)Custom ID with no headers
              </DialogContentText>
              <DialogContentText sx={{ textAlign: 'center' , whiteSpace: 'normal', wordWrap: 'break-word', marginBottom: 2}}>
                <b>A download option is available above to access a sample template for reference before uploading your file. The template file contains the headers as well, but please ensure to remove the headers before uploading.</b>
              </DialogContentText>
              <Box
                noValidate
                component="form"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  m: 'auto',
                  width: 'fit-content',
                }}
              >        
              <FormControl sx={{ mt: 2, minWidth: 120 }}>              
                <input type="file" accept=".csv,.xlsx,.xls" onChange={handleFileUpload}/>
              </FormControl>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          </Dialog>
      </DialogContent>
    </Dialog>
  );
};

export default UnknowAssetsUpload;
